import {Entity} from './Entity';
import {finances} from '../actions/financesArray.js';
import {EntitiesArray} from '../components/island';

export class EntityGovernment extends Entity {
  constructor(init){
    init.type = "government";
    init.totalSlots = 0;
    init.instructionsPath = "http://www.google.com/file.pdf";
    super(init);

    this.activeSubsidies = init.subsidies || [];
    this.activeTaxes = init.taxes || [];

    this.subsidyAvailable = init.subsidyAvailable || [true, true, true, true, true, true, true, true, true];
    this.taxAvailable = init.taxAvailable || [true, true, true, true, true, true, true, true, true];

    this.oldRound = 0;
  }

  getAvailableFinance( type ) {
    let selectedFinances = [];

    try {
      if(type === "subsidy"){
        for (var i = 0; i < finances.length; i++) {
          if (finances[i].type === "subsidy" && !finances[i].active) {
            selectedFinances.push(finances[i]);
          }
        }
      } else if(type === "tax"){
        for (var d = 0; d < finances.length; d++) {
          if (finances[d].type === "tax" && !finances[d].active) {
            selectedFinances.push(finances[d]);
          }
        }
      } else {
        throw new Error("Onbekend type");
      }

      return selectedFinances;
    } catch(e) {
      console.log(e);
      return false;
    }
  }

  getFinances(type){
    if(type === 'green'){
      let subsidies = finances.filter((current) => {return current.type === "subsidy" && current.active === true}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return subsidies;
    } else if(type === 'smartAppliances'){
      let smartAppliances = finances.filter((current) => {return current.id === 0 && current.active === true}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return smartAppliances;
    } else if(type === 'decentrals'){
      let decentrals = finances.filter((current) => {return current.id === 1 && current.active === true}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return decentrals;
    } else if(type === 'windfarms'){
      let windfarms = finances.filter((current) => {return current.id === 2 && current.active === true}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return windfarms;
    } else if(type === 'solarfarms'){
      let solarfarms = finances.filter((current) => {return current.id === 3 && current.active === true}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return solarfarms;
    } else if(type === 'coalPower'){
      let affects = [4, 5];
      let coalPower = finances.filter((current) => {return affects.includes(current.id) && current.active === true}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return coalPower;
    } else if(type === 'gasCoalPower'){
      let affects = [6, 7];
      let gasCoalPower = finances.filter((current) => {return affects.includes(current.id) && current.active === true}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return gasCoalPower;
    } else if(type === 'blackPermit'){
      let solarfarms = finances.filter((current) => {return current.id === 8 && current.active === true}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return solarfarms;
    } else if(type === "boughtMWU"){
      let power = finances.filter((current) => {return current.type === "tax" && current.active === true && current.id !== 8}).reduce((accumilator, current) => {return accumilator += current.amount}, 0);
      return power;
    } else if(type === "mwuGreen"){
      let mwuGreen = EntitiesArray.reduce((accumilator, current) => {return accumilator += current.getMwuGreen()}, 0);
      return mwuGreen;
    } else if(type === "BNP"){
      let city1 = EntitiesArray[0];
      let city2 = EntitiesArray[1];
      let company1 = EntitiesArray[2];
      let company2 = EntitiesArray[3];

      let productionCompany1 = (company1.getMwuServices() / company1.getMwuNecessity() * 100);
      let productionCompany2 = (company2.getMwuServices() / company2.getMwuNecessity() * 100);

      let penaltyCity1 = (city1.getMwuServices() / city1.getMwuNecessity() * 100);
      penaltyCity1 = (penaltyCity1 < 100 ? penaltyCity1 - 100 : 0);

      let penaltyCity2 = (city2.getMwuServices() / city2.getMwuNecessity() * 100);
      penaltyCity2 = (penaltyCity2 < 100 ? penaltyCity2 - 100 : 0);

      let scoreCity1 = productionCompany1 - penaltyCity1;
      let scoreCity2 = productionCompany2 - penaltyCity2;

      return (scoreCity1 + scoreCity2) /2;
    }
  }

  selectNewFinance( data ) {
    try {
      const type = data.type;
      for (var i = 0; i < finances.length; i++) {
        if( finances[i].name === data.name && !finances[i].active ) {
          let proceed = false;

          if(finances[i].type === "tax"){
            if(this.taxAvailable[this.round-1]){
              proceed = true;
              this.taxAvailable[this.round-1] = false
            } else {
              proceed = false;
            }
          } else if(finances[i].type === "subsidy") {
            if(this.subsidyAvailable[this.round-1]){
              proceed = true;
              this.subsidyAvailable[this.round-1] = false
            } else {
              proceed = false;
            }
          }

          if(!proceed) {
            throw new Error(type + " is niet langer beschikbaar in dit jaar!")
          } else {
            finances[i].active = true;
          }
          break;
        }
      }
    } catch (e) {
      return e;
    }
  }

  updateDataValues = (values) => {
     //console.log("values:", this, values);
    Object.keys(values).forEach((val) => {
      this[val] = values[val];
    });
  }
}



// WEBPACK FOOTER //
// ./src/classes/EntityGovernment.js